/* eslint-disable react/prop-types */
import React from 'react';
import classnames from 'classnames/bind';
import styles from './page-content-panel.less';

const cx = classnames.bind(styles);

const PageContentPanel = ({ className, header, message, children }) => (
  <div className={cx(styles.Content, className)}>
    {header && <h3 className={styles.Header}>{header}</h3>}
    {message && <p className={styles.Message}>{message}</p>}
    {children}
  </div>
);

export default PageContentPanel;
